import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShift: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShift"><Path d="M2 13.5L12 2.5L22 13.5H17.5V20.5H6.5V13.5H2Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShift;
